// activity.ts - 운영 콘솔 활동 지표의 표시용 순수 변환.
// 집계는 서버가 한다(`/api/superadmin/activity`). 여기서는 차트 입력과
// 파생 지표(일평균 등)만 만든다 - 컴포넌트에 계산을 섞지 않는다.

import type { BarPoint } from "@/components/charts";
import type { ActivityPoint } from "@/lib/api";
import { monthDay } from "@/lib/dates";

/** 조회 가능한 구간(일). 서버 상한은 90 이다. */
export const ACTIVITY_RANGES = [7, 14, 30, 90] as const;

/**
 * 일별 요청 수를 BarTrend 입력으로. `done` 은 그날 접속한 유저 수다 -
 * 요청 막대 안에 겹쳐 그려서 "요청이 몇 명에게서 나왔나"를 같이 읽는다.
 */
export const toBars = (daily: ActivityPoint[]): BarPoint[] =>
  daily.map((d) => ({ m: monthDay(d.date), total: d.requests, done: d.active_users }));

/** 하루 평균 요청 수 (소수 1자리). 구간이 비면 0. */
export const avgPerDay = (total: number, days: number): number =>
  days > 0 ? Math.round((total / days) * 10) / 10 : 0;

/** 오늘(구간 마지막 날) 접속한 유저 수. 구간이 비면 0. */
export const activeToday = (daily: ActivityPoint[]): number =>
  daily.length > 0 ? daily[daily.length - 1].active_users : 0;
